import * as React from 'react';
import { connect } from 'react-redux';

import translate from '../locale/translate';
import {
    Authentication as AuthenticationAction,
    Customer as CustomerAction,
    Tag as TagAction,
    ReportTemplate as ReportTemplateAction,
} from '../actions'

import IState, { IAuthenticationState } from '../interfaces/states';

import Circle from './loading/Circle';
import { getErrorObject, IError } from './widget/util/RemoteDataUtil';

interface IOwnProps {
    rtId?: string,
}

interface IStateProps {
    authentication: IAuthenticationState,
}

interface IDispatchProps {
    authenticate: Function,
    listCustomers: Function,
    listTags: Function,
    loadTemplate: Function,
}

type IProps = IOwnProps & IStateProps & IDispatchProps;

class AppContainer extends React.Component<IProps, void> {
    static propTypes = {
        rtId: React.PropTypes.string,
        authentication: React.PropTypes.object.isRequired,
        authenticate: React.PropTypes.func.isRequired,
        listCustomers: React.PropTypes.func.isRequired,
        listTags: React.PropTypes.func.isRequired,
        loadTemplate: React.PropTypes.func.isRequired,
    };

    constructor(props: IProps) {
        super(props);

        this.props.authenticate('main');
        this.doSetup(props);
    }

    componentDidUpdate(prevProps: IProps) {
        if (this.props.authentication !== prevProps.authentication) {
            this.doSetup(this.props);
        }
    }

    doSetup(props: IProps) {
        const { authenticated } = props.authentication;

        if (!authenticated) {
            return;
        }

        this.props.listCustomers('main');
        this.props.listTags('main');

        if(this.props.rtId) {
            this.props.loadTemplate('main', this.props.rtId);
        }
    }

    renderNotAuthenticated() {
        const errorText = "You are currently not logged in. Please visit https://occ.server-eye.de and log in.";
        const errObj: IError = {
            widgetName: 'AppContainer',
            message: 'Not authenticated',
            error: {
                status: 401
            }
        };

        return (
            <div className="jumbotron m-xl">
                <h1>{translate.gettext("Not authenticated")}</h1>
                <p>{translate.gettext(errorText)}</p>
                <pre className="se-4backend-err" style={{ "display": "none" } as React.CSSProperties}>{JSON.stringify(errObj)}</pre>
            </div>
        );
    }

    renderLoading() {
        return (
            <Circle size="xxl" name='AppContainer' infinite />
        );
    }

    renderChildren() {
        const { children } = this.props;

        return (
            <div>{children}</div>
        );
    }

    render() {
        const { loading, authenticated, error } = this.props.authentication;

        if (loading) {
            return this.renderLoading();
        }

        if (!authenticated) {
            return this.renderNotAuthenticated();
        }

        return this.renderChildren();
    }
}

const mapStateToProps = (state: IState) => ({
    authentication: state.authentication,
});

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    {
        authenticate: AuthenticationAction.getMe,
        listCustomers: CustomerAction.listCustomers,
        listTags: TagAction.listTags,
        loadTemplate: ReportTemplateAction.loadSingle,
    }
)(AppContainer);


// WEBPACK FOOTER //
// ./src/components/AppContainer.tsx